import { BONUS_AVAILABLE_GET_SUCCESS, BONUS_AVAILABLE_GET_FAILURE } from '../actions/types';
import config from '../configs';

const initialState = {
  config,
  placements: [],
  isLoading: false,
  isLoaded: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BONUS_AVAILABLE_GET_SUCCESS: {
      return {
        ...state,
        placements: action.payload.response,
        isLoading: false,
        isLoaded: true,
      };
    }
    case BONUS_AVAILABLE_GET_FAILURE: {
      return {
        ...state,
        placements: [],
        isLoading: false,
        isLoaded: true,
      };
    }
    default: {
      const { options = {} } = action;
      if (options.success === BONUS_AVAILABLE_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};
